import { initializeApp } from "firebase/app";
import { getAuth, browserLocalPersistence, setPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDMDZkXJK1wD3Fe42mHQOyBZJ-yE-NfzcM",
  authDomain: "ccconnectapp.com",
  projectId: "community-connect-c4ec0",
  storageBucket: "community-connect-c4ec0.appspot.com",
  messagingSenderId: "736265674455",
  appId: "1:736265674455:web:184e2e90dcf8587b145a92"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

(async () => {
  try {
    await setPersistence(auth, browserLocalPersistence);
  } catch (err) {
    console.warn("setPersistence error:", err);
  }
})();

export { auth, db, storage };
